import React from 'react';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import { numericality } from 'redux-form-validators';
import { PORT_RESTRICTIONS } from 'constants/ports';
import './PortRestrictions.scss';
import PropTypes from 'prop-types';
import { formName } from 'data/formNames';
import { connect } from 'react-redux';


const PortRestrictionsForm = ({ handleSubmit, onCancel }) => (
    <div className="port-restrictions-block">
        <div className="restrictions-grid">
            {PORT_RESTRICTIONS.map(({ name, label }) => (
                <div key={name} className="restriction-item">
                    <Field
                        name={`portLimitations.${name}`}
                        component={TextField}
                        floatingLabelText={label}
                        floatingLabelStyle={{ fontSize: '12px' }}
                        validate={[numericality({ '>=': 0, allowBlank: true })]}
                        fullWidth
                        parse={(value) => {
                            if (value === '' || value === null || value === undefined) return '';
                            // replace comma with dot
                            const normalized = value.replace(',', '.');
                            // allow only numbers, dot, and comma
                            if (!/^[0-9]*[.,]?[0-9]*$/.test(value)) return '';
                            // if value ends with a dot or comma, return as string so user can keep typing
                            if (/[.,]$/.test(value)) return value;
                            const asNumber = Number(normalized);
                            return isNaN(asNumber) ? value : asNumber;
                        }}
                        inputProps={{
                            inputMode: 'decimal',
                            pattern: '[0-9.,]*',
                        }}
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9.,]/g, '');
                        }}
                    />
                </div>
            ))}
        </div>
        <div className="form-actions">
            <RaisedButton
                label="Save"
                primary
                onClick={handleSubmit}
            />
            <RaisedButton
                label="Cancel"
                secondary
                onClick={onCancel}
            />
        </div>
    </div>
);

PortRestrictionsForm.propTypes = {
    portLimitations: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

const selector = formValueSelector(formName.portUpdate);
const mapStateToProps = state => ({
    portLimitations: selector(state, 'portLimitations'),
});

export default connect(mapStateToProps)(reduxForm({
    form: formName.portUpdate,
    enableReinitialize: true,
})(PortRestrictionsForm));



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/PortRestrictions/PortRestrictionsForm.jsx